/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require('./bootstrap');
require('jvectormap');
require('./lib/jquery-jvectormap-world-mill');

window.Vue = require('vue');

import store from './store/index'
import VModal from 'vue-js-modal'
import {BootstrapVue} from 'bootstrap-vue'
import router from './router'

Vue.use(VModal, {dynamic: true, injectModalsContainer: true, dynamicDefaults: { clickToClose: false }})
Vue.use(BootstrapVue)

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))
Vue.component('images', require('./components/Images').default);
Vue.component('pages', require('./components/Pages').default);
Vue.component('sidebar', require('./components/Sidebar').default);
Vue.component('searchbar', require('./components/search/Searchbar').default);
Vue.component('search-result', require('./components/search/SearchResult').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// For translations
Vue.prototype.__ = string => _.get(window.i18n, string);

const app = new Vue({
    el: '#app',
	store,
	router,
});

export default app;

//Minimize sidebar
$('#minimize-sidebar').click(function () {
	if ($('.page-wrapper').hasClass('pinned')) {
	    // expand sidebar when hovered
	    $('.page-wrapper').removeClass('pinned');
	    $('#sidebar').unbind('hover');
	} else {
	    $('.page-wrapper').addClass('pinned');
	    $('#sidebar').hover(function () {
	    	$('.page-wrapper').addClass('sidebar-hovered');
	    }, function () {
	    	$('.page-wrapper').removeClass('sidebar-hovered');
	    });
	}
});

//Bind hover if 'pinned' is initially enabled
if ($('.page-wrapper').hasClass('pinned')) {
	$('#sidebar').hover(
		function () {
			$('.page-wrapper').addClass('sidebar-hovered');
		},
		function () {
			$('.page-wrapper').removeClass('sidebar-hovered');
		}
	);
}

//Sidebar dropdown menu
$(document).ready(function() {
	$('.sidebar-dropdown > a').click(function () {
		$('.sidebar-submenu').hide();
		if ($(this).parent().hasClass('active')) {
			$('.sidebar-dropdown').removeClass('active');
			$(this).parent().removeClass('active');
		} else {
			$('.sidebar-dropdown').removeClass('active');
			$(this).next('.sidebar-submenu').show();
			$(this).parent().addClass('active');
			
			// Bring the parent menu to the view.
			var elementOffsetTop = $(this).offset().top;
			var elementHeight = $(this).height();
			var sidebarHeight = $('.sidebar-content').height();
			var offset = (elementHeight < sidebarHeight) ? elementOffsetTop - ((sidebarHeight / 2) - (elementHeight / 2)) : elementOffsetTop;
			
			$('.sidebar-menu').animate({
			    scrollTop: offset
			}, 200);
		}
	});
});

/**
 * Update tags count on the home/main page.
 * @param artifact
 */
window.updateTagsCount = function(artifact) {
	$('.image-result[data-id="' + artifact.type + '-' + artifact.id + '"]').find('#tags_count').text(artifact.tags.length);
}

//Add a response interceptor
axios.interceptors.response.use(undefined, error => {	
	// Any status codes that falls outside the range of 2xx cause this function to trigger
	if(error.response.status === 401 && window.location.pathname !== '/login') {
    	window.location.replace('/timeout');
    }
	
	return Promise.reject(error);
});